import { action } from "../common/Action"
import ContrattiActions from "../contratti/ContrattiActions";
import { ImpiantiClimaClient, ImpiantoClimaData } from "../generated";
import ImpiantiClienteActions from "../impianti/ImpiantiClienteActions";
import InterventiActions from "../interventi/InterventiActions";

const service = new ImpiantiClimaClient();

class ImpiantiClimaActions {

    @action
    async get(id: number) {
        return (await service.get(id))!
    };

    @action
    async add(impianto: ImpiantoClimaData) {
        const id = await service.add(impianto);
        await ImpiantiClienteActions.getForCustomer(impianto.idCliente);
        return (await service.get(id))!;
    }
    @action
    async update(impianto: ImpiantoClimaData, idImpianto: number) {
        await service.update(impianto, idImpianto);
        await ImpiantiClienteActions.getForCustomer(impianto.idCliente);
        return (await service.get(idImpianto))!;
    }

    @action
    async delete(idCliente: number, idImpianto: number) {
        const deleteOk = await service.delete(idImpianto);
        await ImpiantiClienteActions.getForCustomer(idCliente);
        if (deleteOk) {
            InterventiActions.getByCustomer(idCliente);
            ContrattiActions.getByImpianto(idImpianto);
        }
        return { impiantoId: idImpianto, idCliente, deleteOk };
    }
}
export default new ImpiantiClimaActions();